import classNames from 'classnames';
import React from 'react';

import styles from './TableCell.module.scss';

export type TableCellProps = {
  children: React.ReactNode;
  isRowTitle?: boolean;
  className?: string;
  align?: 'left' | 'center' | 'right';
  colSpan?: number;
  isMonday?: boolean;
};

const TableCellComponent: React.FC<TableCellProps> = ({
  children,
  isRowTitle = false,
  className = '',
  align = 'center',
  colSpan,
  isMonday = false,
}) => {
  return (
    <div
      className={classNames(
        styles.tableCell,
        {
          [styles.alignLeft]: align === 'left',
          [styles.alignCenter]: align === 'center',
          [styles.alignRight]: align === 'right',
          [styles.rowTitle]: isRowTitle,
          [styles.isMonday]: isMonday,
        },
        className
      )}
      style={{ gridColumn: colSpan ? `span ${colSpan}` : undefined }}
    >
      {children}
    </div>
  );
};

export const TableCell = React.memo(TableCellComponent);
